import { Outlet } from "react-router"
import {
	Container,
	Heading,
	Stack,
	TabContent,
	Tabs,
	TabsList,
} from "@sembark-travel/ui-base"
import { NavLink } from "@sembark-travel/ui-router"
import { generatePath } from "../../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"

export default function AutomationsLayout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_INTEGRATIONS}>
			<Stack gap="4">
				<Container>
					<Heading>Automations</Heading>
				</Container>
				<Tabs layout="col" gap="6">
					<TabsList>
						<NavLink to={generatePath("/org/automations/definitions")}>
							Definitions
						</NavLink>
						<NavLink to={generatePath("/org/automations/schedules")}>
							Schedules
						</NavLink>
						<NavLink to={generatePath("/org/automations/runs")}>Runs</NavLink>
					</TabsList>
					<TabContent>
						<Outlet />
					</TabContent>
				</Tabs>
			</Stack>
		</ForbidUnlessAuthorized>
	)
}
